export default {
  Routes: {
    'read:any': ['*'],
  }
}
